import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactModal from 'react-modal';
import { colors, colorUtils } from '@prisjakt/ui-base';
import CloseIcon from 'mdi-react/CloseIcon';

import * as S from './index.styles';

const APP_ROOT_ID = 'root';
const MODAL_ROOT_ID = 'root-modal';

const getModalRoot = () => document.getElementById(MODAL_ROOT_ID);

const Modal = props => {
  React.useEffect(() => {
    ReactModal.setAppElement(`#${APP_ROOT_ID}`);
  }, []);

  const {
    id,
    current,
    isOpen,
    verticalScroll,
    width,
    children,
    center,
  } = props;

  return (
    <S.Modal
      {...props}
      isOpen={isOpen || (!!current && current === id)}
      parentSelector={getModalRoot}
      verticalScroll={verticalScroll}
      center={center}
      style={{
        content: { width },
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          height: '100%',
          width: '100%',
          background: colorUtils.setRgbaAlpha(colors.darkBlue1, '0.8'),
          overflow: 'auto',
          zIndex: 102,
          overflowY: 'scroll',
          '-webkit-overflow-scrolling': 'touch',
          display: 'flex',
          justifyContent: 'center',
        },
      }}
    >
      <S.Wrapper data-test={props['data-test']}>
        {verticalScroll ? <S.Viewport>{children}</S.Viewport> : children}
        {props.shouldShowCloseIcon && (
          <S.CloseButton
            variant="icon"
            onClick={() => props.onRequestClose()}
            tabIndex={0}
            icon={<CloseIcon />}
            data-test="ModalDialogCloseButton"
          />
        )}
      </S.Wrapper>
    </S.Modal>
  );
};

const { node, func, bool, number, string, oneOfType } = PropTypes;
Modal.propTypes = {
  current: string,
  id: string,
  isOpen: bool,
  children: node,
  onRequestClose: func,
  width: oneOfType([number, string]),
  shouldShowCloseIcon: bool,
  shouldCloseOnOverlayClick: bool,
  verticalScroll: bool,
  'data-test': string,
  center: bool,
};

Modal.defaultProps = {
  current: undefined,
  id: undefined,
  isOpen: false,
  children: null,
  onRequestClose: () => {},
  width: 'auto',
  shouldShowCloseIcon: true,
  shouldCloseOnOverlayClick: true,
  verticalScroll: false,
  'data-test': undefined,
  center: false,
};

export default connect(state => ({ ...state.modal }))(Modal);
